import script from "./xtx-tabs.vue?vue&type=script&lang=jsx"
export * from "./xtx-tabs.vue?vue&type=script&lang=jsx"

import "./xtx-tabs.vue?vue&type=style&index=0&id=1a2b7454&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a2b7454"]])

export default __exports__